import { Component, OnInit } from "@angular/core";
import { SessionService } from "@recore-solutions/nstar-lib";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
	selector: "app-logout",
	template: `<p>Logging out...</p>`,
})
export class LogoutComponent implements OnInit {
	constructor(private oauthService: OAuthService, private sessionService: SessionService) {}
	ngOnInit(): void {
		this.oauthService.stopAutomaticRefresh();
		localStorage.removeItem("session_id");
		this.sessionService.clearLegacySamlCookies();
		this.oauthService.logOut();
	}
}
